import { Button, Spacer, SvgArrowRight, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'selectors/user';

import styles from './styles.module.less';

function ValuePropStep({ handleNextStep }) {
  const user = useSelector(selectCurrentUser);

  return (
    <>
      <Text size="large" fontWeight="bold">
        Welcome {user.first_name}!
      </Text>
      <Spacer bottom="small" />
      <Text size="medium">
        A Loom account has been created for you via Slack. Get started to:
      </Text>
      <Spacer bottom="medium" />
      <ul className={styles.listContainer}>
        <li className={styles.listItem}>
          <Text size="small">Share updates between coworkers</Text>
          <Spacer bottom="small" />
        </li>
        <li className={styles.listItem}>
          <Text size="small">Ask for feedback on a project</Text>
          <Spacer bottom="small" />
        </li>
        <li className={styles.listItem}>
          <Text size="small">Send an update ahead of a meeting</Text>
          <Spacer bottom="medium" />
        </li>
      </ul>

      <div className="flex justify:flexEnd">
        <Button
          variant="primary"
          icon={<SvgArrowRight color="white" />}
          iconPosition="right"
          onClick={() => handleNextStep()}
        >
          Finish Account Setup
        </Button>
      </div>
    </>
  );
}

export default ValuePropStep;
